import styled, { keyframes } from 'styled-components';
import * as SpinnerIcon from 'react-icons/lib/io/load-c';

const rotate360 = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;
export default styled<any>(SpinnerIcon)`
    display: inline-block;
    animation: ${rotate360} 1s linear infinite;
    transform-origin: 44% 50%; /* fix wobbly spinning */
    margin-bottom: 5px;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Spinner.tsx